<template>
	<div>
		<li>
			<a href="#cover" class="active"> Cover</a>
		</li>
		<li v-for="(section, section_key) in bookSections" :key="section_key">
			<a :href="'#'+section.clip_type.slug" class="smoth-scroll"> {{ section.clip_type.name }}<span class="cnt">({{ sectionWithCounter(section.id) }})</span> </a>
		</li>
	</div>
</template>

<script>

export default {
	props: ['bookId', 'currentUser', 'bookSections', 'clipTypes'],
	data() {
		return  {
			clipInsert: false,
			// sectionList: this.sectionList,
		}
	},
	computed: {
		allClipList: function () {
			return this.$store.state.savedClipList;
		},
		existingClips: function () {
			return $.map( this.allClipList, function( clip ) {
				return clip.id;
			});
		}
	},
	mounted () {
		this.$parent.setData(this.bookId, 'frist-time');
	},
	methods: {
		slug (text) {
			return text.toString().toLowerCase().trim()
				    .replace(/\s+/g, '-')           // Replace spaces with -
				    .replace(/&/g, '-and-')         // Replace & with 'and'
				    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
				    .replace(/\-\-+/g, '');

		},
		sectionWithCounter(section){
			var vm = this;

			var section_clips = this.$store.state.sections;
			// var section_clips = [];
			var total_clips = section_clips[section];

			if (typeof total_clips === "undefined") {
			    total_clips = 0;
			}
			return total_clips;
		}
	}
}
</script>